import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "styled-components";
import { GlobalStyles, theme } from "./GlobalStyles";

import DarkStyles from "./DarkStyles";
import LightStyles from "./LightStyles";

const PageContainer = ({ children, nightmode }) => (
  <ThemeProvider theme={{ ...theme, nightmode }}>
    <>
      <GlobalStyles />
      {nightmode ? (
        <DarkStyles>{children}</DarkStyles>
      ) : (
        <LightStyles>{children}</LightStyles>
      )}
    </>
  </ThemeProvider>
);

PageContainer.propTypes = {
  children: PropTypes.node,
  nightmode: PropTypes.bool
};

export default PageContainer;
